import React from "react";
import "../supplierAndManufacturers.scss";
import { Form } from "react-bootstrap";

const CheckItem = ({
  disable = false,
  label = '',
  value = false,
  onClick = (value) => { },
}) => {
  return (
    <div className="hg-check-item">
      <Form.Group className={`square-checkbox ${disable ? 'gray-checkbox' : 'blue-checkbox pointer-checkbox'} mb-1`}>
        <Form.Check
        disabled={disable}
          type="checkbox"
          label=""
          name={`checkbox`}
          checked={value}
          onChange={(e) => { onClick(!value) }}
        />
      </Form.Group>
      <span className={`label mt-2 ml-1 ${disable ? 'f-darkgrey' : ''}`}>{label}</span>
    </div>


  );
};

export default CheckItem;
